module.exports = __webpack_public_path__ + "media/warning.acd9901f.mp3";